// Gedeelde opmaak voor PrimaryButton, SecondaryButton, SuccessButton en ErrorButton.
export const buttonBase =
  "flex items-center justify-center gap-2 rounded-xl font-semibold transition-colors disabled:opacity-60";

export const buttonSizes = {
  sm: "px-3.5 py-2 text-[13px]",
  md: "px-5 py-2.5 text-sm",
};

export const buttonClasses = (variant, size = "md", className = "") =>
  `${buttonBase} ${buttonSizes[size] || buttonSizes.md} ${variant} ${className}`;
